import React, { useEffect, useState } from 'react';
import styles from './payment-method.module.css';
import { BasicInfoSection } from 'app/shared/info-section/basic';
import card_icon from 'assets/svg/card.svg';
import { useBillingService } from 'hooks/sales/billing';
import { GridColumn, GridRow } from 'app/layouts/grid';
import { Button } from 'app/shared/button';
import { prepareCheckoutConfig } from 'app/member/modules/wallet/helper';
import { useCurrencyService } from 'hooks/sales/currency';
import { toast } from 'react-toastify';
import { useTenant } from 'contexts/tenant';
import { usePaymentService } from 'hooks/sales/payment';

export const PaymentMethod = () => {
  const { tenant, is_agency_managed } = useTenant();

  const { fetchBillingInfos } = useBillingService();
  const { fetchCurrencies } = useCurrencyService();
  const { createPayment } = usePaymentService();

  const [billing_info, setBillingInfo] = useState({});
  const [currency, setCurrency] = useState({});
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    fetchBillingInfos().then(({ billing_infos: [info], error }) => {
      if (error) return;
      setBillingInfo(info);
    });
  }, []);

  useEffect(() => {
    fetchCurrencies().then(({ currencies, error }) => {
      if (error) {
        return;
      }

      if (currencies.length) {
        const mapped_currency = currencies.map((curr) => ({
          ...curr,
          label: curr.name,
          value: curr.code
        }));
        setCurrency(
          mapped_currency.find((option) => option.country_code === billing_info?.country)
        );
      }
    });
  }, [billing_info]);

  const CardDetails = ({ data }) => {
    return (
      <>
        <GridRow num_of_columns={6}>
          <GridColumn span={1}>
            <img src={card_icon} alt="card logo" className={styles.img} />
          </GridColumn>
          <GridColumn span={5}>
            <div
              className={styles.payment_info}
            >{`CARD ENDING IN ${data.payments?.details.last_4digits}`}</div>
            <div
              className={styles.payment_sub_info}
            >{`Expires on ${data.payments?.details.expiry}`}</div>
          </GridColumn>
        </GridRow>
      </>
    );
  };

  const handlePaymentMethod = async () => {
    if (!tenant || !tenant.id) return toast.error('Unable to process tenant data');
    if (!billing_info || !billing_info.country)
      return toast.error('Unable to process billing data');
    if (!currency || !currency.code) return toast.error('Unable to process currency data');

    setLoading(true);
    const TEST_FEE = 10;
    const config = prepareCheckoutConfig({
      tenant,
      amount: TEST_FEE,
      currency,
      payment_options: 'card',
      tx_reason: 'card-fee'
    });
    const data = {
      currency: currency.value,
      conversion_rate: currency.exchange_rate,
      amount: TEST_FEE,
      tenant_id: tenant.id,
      tx_ref: config.tx_ref,
      reason: 'card-fee'
    };

    const payment_record = await createPayment({ data });
    if (payment_record) {
      window.FlutterwaveCheckout(config);
    }
    setLoading(false);
  };

  return (
    <>
      <BasicInfoSection title="Payment Methods">
        {billing_info?.payments?.details ? (
          <CardDetails data={billing_info} />
        ) : (
          <p className={styles.message}> No Payment method available </p>
        )}
        {!is_agency_managed && (
          <Button
            onClick={handlePaymentMethod}
            text="Add Payment Method"
            loading={loading}
            disabled={loading}
          />
        )}
      </BasicInfoSection>
    </>
  );
};
